import React from "react";
import { PictureOutlined } from "@ant-design/icons";
import { DeploymentUnitOutlined } from "@ant-design/icons";
import { EnvironmentOutlined } from "@ant-design/icons";
import { ExperimentOutlined } from "@ant-design/icons";
import { SoundOutlined } from "@ant-design/icons";
import { BuildOutlined } from "@ant-design/icons";
import { ToolOutlined } from "@ant-design/icons";

interface Props {
  type: string;
}

const DynamicIcon: React.FC<Props> = (props) => {
  const { type } = props;
  switch (type) {
    case "picture":
      return <PictureOutlined className="icon" />;

    case "deployment-unit":
      return <DeploymentUnitOutlined className="icon" />;

    case "environment":
      return <EnvironmentOutlined className="icon" />;

    case "build":
      return <BuildOutlined className="icon" />;

    case "audio":
      return <SoundOutlined className="icon" />;

    case "tools":
      return <ToolOutlined className="icon" />;

    default:
      return <ExperimentOutlined className="icon" />;
  }
};

export default DynamicIcon;
